import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import FaqEntry from 'src/pages/admin/faq/FaqEntry';
import faqService from '../services/faq/faq.service';
const FaqsViewer = () => {
  const {
    faqs
  } = faqService.useCrud();
  const userLanguage = useSelector(state => state.auth.user.local_language);
  const {
    t
  } = useTranslation();
  return faqs.map(faq => faq.faq_entries.filter(faqEntry => faqEntry.language === userLanguage).map(faqEntry => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FaqEntry, {
      data: faqEntry,
      editMode: false
    }));
  }));
};
export default FaqsViewer;